import { useEffect, useState } from "react";

import { isPreviewBrowserHost } from "@/lib/forms/lead-host";

/**
 * Shown only on a non-production host, for example a Workers Builds preview
 * (8 Oct 2026). On that host the server sends no lead (lead-host.server.ts).
 * The bar shows this to a tester on a phone, where no header can be set.
 *
 * Rendered after mount, so the server HTML and production pages never hold
 * it. pointer-events: none, so it never takes a tap (a tap can count as
 * consent while the OneTrust banner is open).
 */
export function PreviewBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(isPreviewBrowserHost());
  }, []);
  if (!show) return null;
  return (
    <div
      role="status"
      data-testid="preview-banner"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2147483646,
        pointerEvents: "none",
        background: "#b45309",
        color: "#fff",
        font: "600 12px/20px system-ui, sans-serif",
        textAlign: "center",
        padding: "2px 8px",
      }}
    >
      Preview: test mode, no lead is sent
    </div>
  );
}
